// extracted by mini-css-extract-plugin
module.exports = {"valueWrap":"value-wrap___2dbVs"};